// Validate password required criteria
export const validatePassword = (value) => {
  if (!value) return true;
  const hasMinLength = value.length >= 8;
  const hasCapitalLetter = /[A-Z]/.test(value);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
  return hasMinLength && hasCapitalLetter && hasSpecialChar;
};

// Check individual password criteria
export const checkPasswordCriteria = (value) => {
  if (!value) return { minLength: false, capitalLetter: false, specialChar: false };
  return {
    minLength: value.length >= 8,
    capitalLetter: /[A-Z]/.test(value),
    specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(value)
  };
};
